module.exports = __webpack_public_path__ + "img/t7.861ee603.png";